import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Reviews from "./components/Reviews";
import Videos from "./components/Videos";
import Packages from "./components/Packages";
import BeforeAfter from "./components/BeforeAfter";
import WhyChoose from "./components/WhyChoose";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import SEODashboard from "./components/SEODashboard";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Hero />
      <Services />
      <Reviews />
      <Videos />
      <Packages />
      <BeforeAfter />
      <WhyChoose />
      <FAQ />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={
            <>
              <Navbar />
              <Blog />
              <Footer />
            </>
          } />
          <Route path="/blog/:slug" element={
            <>
              <Navbar />
              <BlogPost />
              <Footer />
            </>
          } />
          <Route path="/seo-dashboard" element={
            <>
              <Navbar />
              <SEODashboard />
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;

